import {
  Button,
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
  FormLabel,
  Divider,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { makeStyles } from "@mui/styles";
import { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import Switch from "@mui/material/Switch";
// import Link from "@mui/material/Link";
import { Link, useHistory } from "react-router-dom";
import { rem, isWeb, refreshToken, setCookiesSync } from "assets/js/common";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import { Cookies } from "react-cookie";
import axios from "axios";
import moment from "moment";
import DrawerComplete from "components/ui/drawer-complete";
import { logoutAction } from "redux/reducers/user";
import { loadMainAction } from "redux/reducers/home";
import Loading from "components/ui/loading";
import { setAppData, setPushTag } from "assets/js/apphandle";

const useStyles = makeStyles((theme) => ({
  setting: {
    "& .tit": {
      fontWeight: 400,
    },
  },
}));

const label = { inputProps: { "aria-label": "Switch demo" } };

export default function System(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const cookies = new Cookies();

  let cookieExpires = new Date();
  cookieExpires.setDate(cookieExpires.getDate() + 180);

  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("");
  const [userInfo, setUserInfo] = useState({
    formatRgstYmd: "",
  });
  const [appVer, setAppVer] = useState("");
  // const [gnrPushYn, setGnrPushYn] = useState(false);
  // const [mktPushYn, setMktPushYn] = useState(false);
  // const [mblRctYn, setMblRctYn] = useState(false);
  const [loginYn, setLoginYn] = useState(false);
  const [mainTp, setMainTp] = useState("1");
  const [fetching, setFetching] = useState(false);
  const [issueDate, setIssueDate] = useState("");
  let favInfo = cookies.get("favInfo");

  const handleAlertOpen = (mode) => {
    setMode(mode);
    setOpen(true);
  };
  const handleAlertClose = () => {
    setOpen(false);
  };

  //로그아웃
  const logout = (returnFunc) => {
    if (window.Android) {
      window.Android.logout(returnFunc);
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      // Call iOS interface
      var message = {
        command: "logout",
        func: returnFunc,
      };
      window.webkit.messageHandlers.ios.postMessage(message);
    } else {
      cookies.remove("favInfo", { path: "/" });
      cookies.remove("X-AUTH-TOKEN", { path: "/" });
      cookies.remove("X-REFRESH-TOKEN", { path: "/" });
      cookies.remove("autoToken", { path: "/" });
      dispatch(logoutAction());
      dispatch(
        loadMainAction({
          schTp: "1",
          schStore: "2701",
        }),
      );
      history.push("/");
    }
  };

  const handleLoginOut = () => {
    window.logoutReturnFunc5 = () => {
      cookies.remove("favInfo", { path: "/" });
      cookies.remove("X-AUTH-TOKEN", { path: "/" });
      cookies.remove("X-REFRESH-TOKEN", { path: "/" });
      cookies.remove("autoToken", { path: "/" });
      dispatch(logoutAction());
      dispatch(
        loadMainAction({
          schTp: "1",
          schStore: "2701",
        }),
      );
      setAppData();
      window.location.href = "/";
    };
    logout("logoutReturnFunc5");
  };

  const loadUserInfo = async () => {
    axios
      .get("/api/mb/member/my-info")
      .then((res) => {
        setUserInfo(res.data.data.member);
        setIssueDate(res.data.data.issueDateFormat);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const loadVersion = () => {
    let os = "";
    if (window.Android) {
      os = "android";
    } else if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ios
    ) {
      os = "ios";
    }

    if (os) {
      const reqHeaders = { OS: os };
      axios.post("api/app/ver.do", {}, { headers: reqHeaders }).then((res) => {
        setAppVer(res.data.data);
      });
    }
  };

  const handleChangePush = (e, type) => {
    let checked = e.target.checked;
    axios
      .post("api/mb/member/modify-push", {
        [type]: checked ? "Y" : "N",
      })
      .then((res) => {
        handleAlertOpen(type);
        loadUserInfo();

        let adYn = checked ? "Y" : "N";
        if (type == "mktPushYn") {
          if (window.Android) {
            window.Android.setPushAdYn(adYn);
          } else if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.ios
          ) {
            // Call iOS interface
            var message = {
              command: "setPushAdYn",
              adYn: adYn,
            };
            window.webkit.messageHandlers.ios.postMessage(message);
          }
        }
      });
  };

  //20240119 이걸로 바꿈
  // const handleChangePush = () => {

  //   if (userInfo.mktPushYn == "Y") {
  //     setUserInfo((prev) => ({
  //       ...prev,
  //       mktPushYn: "N",
  //     }));
  //   } else {
  //     setUserInfo((prev) => ({
  //       ...prev,
  //       mktPushYn: "Y",
  //     }));
  //   }

  //   axios
  //     .post("api/mb/member/modify-push", {
  //       mktPushYn: userInfo.mktPushYn == "Y" ? "N" : "Y",
  //     })
  //     .then((res) => {
  //       handleAlertOpen(type);

  //       let adYn = checked ? "Y" : "N";
  //       if (type == "mktPushYn") {
  //         if (window.Android) {
  //           window.Android.setPushAdYn(adYn);
  //         } else if (
  //           window.webkit &&
  //           window.webkit.messageHandlers &&
  //           window.webkit.messageHandlers.ios
  //         ) {
  //           // Call iOS interface
  //           var message = {
  //             command: "setPushAdYn",
  //             adYn: adYn,
  //           };
  //           window.webkit.messageHandlers.ios.postMessage(message);
  //         }
  //       }
  //     });
  // };
  // //광고성 PUSH 알림 진행 전 알림 체크
  // const checkAppPermission = () => {

  //   // //앱 알림 체크 되있는지 확인
  //   if (window.Android) {
  //     //android
  //     if (window.Android.isPushPermissionGranted()) {
  //       handleChangePush();
  //     } else {
  //       //앱 알림 띄운 후 check 되돌리기
  //       handleAlertOpen("permissionCheck");

  //     }

  //   } else if (
  //     //ios
  //     window.webkit &&
  //     window.webkit.messageHandlers &&
  //     window.webkit.messageHandlers.ios
  //   ) {
  //     window.webkit.messageHandlers.ios.appPushPermissionGrantedHandle();

  //     window.appGetHandle = function (json) {
  //       // alert("appGetHandle");
  //       exec(json);
  //       if (json) {
  //         handleChangePush();
  //       } else {
  //         handleAlertOpen("permissionCheck");
  //       }
  //     };
  //   }
  // };

  const handleChangeLoginYn = (e) => {
    let checked = e.target.checked;

    setLoginYn(checked);
    setCookiesSync("checked", checked);
    // cookies.set("checked", checked, {
    //   path: "/",
    //   expires: cookieExpires,
    // });
  };

  const handleChangeReceipt = (e) => {
    let checked = e.target.checked;

    axios
      .post("api/mb/member/modify-mobile-receipt", {
        mblRctYn: checked ? "Y" : "N",
      })
      .then((res) => {
        loadUserInfo();
      });
    //20240119 이걸로 바꿈
    // axios
    //   .post("api/mb/member/modify-mobile-receipt", {
    //     mblRctYn: checked ? "Y" : "N",
    //   })
    //   .then((res) => {
    //     if (checked) {
    //       setUserInfo((prev) => ({
    //         ...prev,
    //         mblRctYn: "Y",
    //       }));
    //     } else {
    //       setUserInfo((prev) => ({
    //         ...prev,
    //         mblRctYn: "N",
    //       }));
    //     }
    //   });
  };

  const handleChangeAppCard = (e) => {
    let checked = e.target.checked;
    // setMblRctYn(checked);
    axios
      .post("api/mb/member/modify-shake-yn", {
        shakeYn: checked ? "Y" : "N",
      })
      .then((res) => {
        loadUserInfo();
        refreshToken();
      });
    //20240119 이걸로 바꿈
    // let checked = e.target.checked;
    // // setMblRctYn(checked);
    // axios
    //   .post("api/mb/member/modify-shake-yn", {
    //     shakeYn: checked ? "Y" : "N",
    //   })
    //   .then((res) => {
    //     if (checked) {
    //       setUserInfo((prev) => ({
    //         ...prev,
    //         shakeYn: "Y",
    //       }));
    //     } else {
    //       setUserInfo((prev) => ({
    //         ...prev,
    //         shakeYn: "N",
    //       }));
    //     }
    //     refreshToken();
    //   });
  };

  const handleChangeMainTp = (e) => {
    setMainTp(e.target.value);
    console.log("e.target.value", e.target.value);
    axios
      .post("api/mb/member/modify-main-tp", {
        mainTp: e.target.value,
      })
      .then(async (res) => {
        if (res.data.data) {
          loadUserInfo();
          setCookiesSync("favInfo", {
            defaultTp: e.target.value,
            visibleTp: e.target.value, //메인 화면에서 변경시키는 tp
            favMk: userInfo.favMk,
            favMt: userInfo.favMt,
          });
          // cookies.set(
          //   "favInfo",
          //   {
          //     defaultTp: e.target.value,
          //     visibleTp: e.target.value, //메인 화면에서 변경시키는 tp
          //     favMk: userInfo.favMk,
          //     favMt: userInfo.favMt,
          //   },
          //   {
          //     path: "/",
          //     expires: cookieExpires,
          //   }
          // );
          await setPushTag();
        }
        console.log("favInfo", favInfo);
      });
  };

  const goAppSetting = () => {
    if (!isWeb) {
      location.href = `csrmegamart://push-config`;
    }
  };

  useEffect(() => {
    // setGnrPushYn(userInfo.gnrPushYn == "Y");
    // setMktPushYn(userInfo.mktPushYn == "Y");
    setMainTp(userInfo.mainTp);
  }, [userInfo]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setFetching(true);
    loadUserInfo();
    setLoginYn(cookies.get("checked") == "true");
    loadVersion();
    // app push
    window.appPushInfoHandle = (data) => {
      handleChangePush();
    };
  }, []);
  //20240119 이걸로 바꿈
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   setFetching(true);
  //   loadUserInfo();

  //   setLoginYn(cookies.get("checked") == "true");
  //   loadVersion();
  // }, []);
  // useEffect(() => {
  //   // setGnrPushYn(userInfo.gnrPushYn == "Y");
  //   // setMktPushYn(userInfo.mktPushYn == "Y");
  //   setMainTp(userInfo.mainTp);
  // }, [userInfo]);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: "설정", menu: true }));
  }, [init]);

  window.appBackKeyHandle = () => {
    if (open) {
      handleAlertClose();
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <Loading open={fetching} />
      <main id="main" className={"container nopad " + classes.setting}>
        <div className="setting">
          {userInfo && (
            <>
              <div className="box-type-1">
                <div className="h-group">
                  <h2>알림</h2>
                  <Button onClick={goAppSetting}>앱 설정 이동</Button>
                  {/* <Link href="#" underline="none" onClick={goAppSetting}>
                  {"앱 설정 이동"}
                </Link> */}
                </div>

                <ul className="setting-list">
                  {/* <li>
                    <b className="tit">일반 PUSH 알림</b>
                    <p className="cont">
                      영수증/포인트 적립 및 사용 정보를 받을 수 있습니다.
                    </p>
                    <Switch
                      {...label}
                      checked={userInfo.gnrPushYn == "Y"}
                      onChange={(e) => handleChangePush(e, "gnrPushYn")}
                    />
                  </li> */}
                  <li>
                    <b className="tit"> 광고성 PUSH 알림</b>
                    <p className="cont">
                      이벤트, 혜택 등의 정보를 받을 수 있습니다.
                      {/* <br />PUSH알림을 받으시려면 우측 상단 '앱 알림 설정'에 들어가
                      <br />'알림 허용'을 활성화 해주세요. */}
                    </p>
                    <Switch
                      {...label}
                      checked={userInfo.mktPushYn == "Y"}
                      onChange={(e) => handleChangePush(e, "mktPushYn")}
                    />
                  </li>
                </ul>
              </div>

              <Divider className="divider-type-2" />

              <div className="box-type-1">
                <div className="h-group">
                  <h2>회원설정</h2>
                </div>

                <ul className="setting-list">
                  <li>
                    <b className="tit">자동 로그인</b>
                    <Switch
                      {...label}
                      checked={loginYn}
                      onChange={handleChangeLoginYn}
                    />
                  </li>
                  <li>
                    <b className="tit">모바일 영수증만 발급받기</b>
                    <Switch
                      {...label}
                      checked={userInfo.mblRctYn == "Y"}
                      onChange={handleChangeReceipt}
                    />
                  </li>
                  <li>
                    <b className="tit">흔들어서 앱카드 열기</b>
                    <Switch
                      {...label}
                      checked={userInfo.shakeYn == "Y"}
                      onChange={handleChangeAppCard}
                    />
                  </li>
                  <li>
                    <Link to={"/setting/password"} className="">
                      <b className="tit">간편 비밀번호 설정/변경</b>
                    </Link>
                  </li>
                  <li>
                    <b className="tit">앱 시작 시 메인화면</b>
                    <FormControl>
                      <RadioGroup
                        row
                        value={mainTp || "1"}
                        onChange={handleChangeMainTp}
                      >
                        <FormControlLabel
                          value="1"
                          control={
                            <Radio
                              color="primary"
                              icon={<span className="radio-icon" />}
                              checkedIcon={
                                <span className="radio-icon-checked" />
                              }
                            />
                          }
                          label="메가마트"
                        />
                        <FormControlLabel
                          value="2"
                          control={
                            <Radio
                              color="primary"
                              icon={<span className="radio-icon" />}
                              checkedIcon={
                                <span className="radio-icon-checked" />
                              }
                            />
                          }
                          label="메가마켓"
                        />
                      </RadioGroup>
                    </FormControl>
                  </li>
                </ul>
              </div>

              <Divider className="divider-type-2" />

              <div className="box-type-1">
                <div className="h-group">
                  <h2>버전 정보</h2>
                </div>

                <ul className="setting-list">
                  <li className="list-flex">
                    <b className="tit">회원 가입일</b>
                    <span className="dec">
                      {issueDate ? issueDate : userInfo.formatRgstYmd}
                    </span>
                  </li>
                  <li className="list-flex">
                    <b className="tit">현재 버전</b>
                    <span className="dec">{appVer.ver}</span>
                  </li>
                  {/* <li className="list-flex">
                  <b className="tit">최신 버전</b>
                  <span className="dec">
                    <Link to={appVer.url || ""} className="btn-link underline">
                      업데이트
                    </Link>
                  </span>
                </li> */}
                </ul>
              </div>

              <Divider className="divider-type-2" />

              <div className="box-type-9">
                <ul className="setting-list">
                  <li>
                    <Button
                      to=""
                      className="btn-text"
                      onClick={() => handleAlertOpen("logout")}
                    >
                      <b className="tit">로그아웃</b>
                    </Button>
                  </li>
                </ul>
              </div>
            </>
          )}
        </div>
        {mode == "logout" ? (
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text={"로그아웃 하시겠습니까?"}
            action={handleLoginOut}
          />
        ) : mode == "gnrPushYn" ? (
          <DrawerComplete
            open={open}
            handleDrawerClose={handleAlertClose}
            text={`일반 알림 수신 ${
              userInfo.gnrPushYn == "Y" ? "동의" : "거부"
            }`}
            subText={`메가마트 앱에서 보내는 일반PUSH 알림<br /> 수신 여부가 ${
              userInfo.gnrPushYn == "Y" ? "'동의'" : "'거부'"
            }로 변경되었습니다.`}
            btmText={`${moment().format("YYYY년 MM월 DD일")}`}
            callback={() => {}}
          />
        ) : (
          //   : mode == "permissionCheck" ? (
          // <DrawerComplete
          //   open={open}
          //   handleDrawerClose={handleAlertClose}
          //   text={`알림 권한 허용 필요`}
          //   subText={`광고성 PUSH 알림을 받으시려면 우측상단<br /> '앱 알림 설정'으로 가신 뒤 알림 허용을 ON으로 설정해주세요`}
          //   callback={() => {
          //     setUserInfo((prev) => ({
          //       ...prev,
          //       mktPushYn: "N",
          //     }));
          //   }}
          // />
          //   )
          <DrawerComplete
            open={open}
            handleDrawerClose={handleAlertClose}
            text={`일반 알림 수신 ${
              userInfo.mktPushYn == "Y" ? "동의" : "거부"
            }`}
            subText={`메가마트 앱에서 보내는 광고PUSH 알림<br /> 수신 여부가 ${
              userInfo.mktPushYn == "Y" ? "'동의'" : "'거부'"
            }로 변경되었습니다.`}
            btmText={`${moment().format("YYYY년 MM월 DD일")}`}
            callback={() => {}}
          />
        )}
      </main>
    </>
  );
}
